import { CustomerSignatureSampleStampResponse } from './../pages/customer-signature-sample-stamp/interface/customer-signature-sample-response';
import { CustomerSignatureSampleStampRequest } from './../pages/customer-signature-sample-stamp/interface/customer-signature-sample-stamp-request';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PageResp } from 'src/app/core/models/page/page-response';

@Injectable({
  providedIn: 'root'
})
export class CustomerSignatureSampleStampService {

  constructor(private http: HttpClient) { }

  getImgUrl(sn: string): string{
    return `${environment.logisticsApiUrl}/CustomerChopSign/chopSign/${sn}`;
  }


  getConsigneeOptionList(type: string): Observable<string[]> {
    const url = `${environment.logisticsApiUrl}/CustomerChopSign/getConsigneeOptionList/${type}`
    return this.http.get<string[]>(url);
  }

  searchCustomerChopSign(request: CustomerSignatureSampleStampRequest): Observable<PageResp<CustomerSignatureSampleStampResponse>> {
    const url = `${environment.logisticsApiUrl}/CustomerChopSign/searchCustomerChopSign`
    return this.http.post<PageResp<CustomerSignatureSampleStampResponse>>(url, request);
  }
}
